import React from 'react';

function Contact() {
  return (
    <div className="flex justify-center items-center  px-5 h-[80vh] ">
      <div className="flex  items-center lg:items-start gap-10 w-[25%]">
        <form className="flex-1 space-y-6 bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-2xl font-semibold text-gray-800">Contact Us</h1>

          <div className="flex items-center bg-gray-100 rounded-lg px-3 border border-gray-300">
            <span className="text-gray-500 pr-2">
              <i className="fa fa-user" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              className="w-full p-3 bg-transparent outline-none rounded-r-lg"
              placeholder="Name"
            />
          </div>

          <div className="flex items-center bg-gray-100 rounded-lg px-3 border border-gray-300">
            <span className="text-gray-500 pr-2">
              <i className="fa fa-envelope" aria-hidden="true"></i>
            </span>
            <input
              type="email"
              className="w-full p-3 bg-transparent outline-none rounded-r-lg"
              placeholder="E-mail"
            />
          </div>

          <textarea
            className="w-full bg-gray-100 p-3 border border-gray-300 rounded-lg outline-none"
            placeholder="Message"
            rows={5}
          ></textarea>

          <button
            type="submit"
            className="w-full bg-primary text-white py-3 rounded-lg shadow-md font-semibold hover:bg-primary/90 transition"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default Contact;
